// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file penumbra/cnidarium/v1/cnidarium.proto (package penumbra.cnidarium.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { KeyValueRequest, KeyValueResponse, NonVerifiableKeyValueRequest, NonVerifiableKeyValueResponse, PrefixValueRequest, PrefixValueResponse, WatchRequest, WatchResponse } from "./cnidarium_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service penumbra.cnidarium.v1.QueryService
 */
export const QueryService = {
    typeName: "penumbra.cnidarium.v1.QueryService",
    methods: {
        /**
         * General-purpose key-value state query API, that can be used to query
         * arbitrary keys in the JMT storage.
         *
         * @generated from rpc penumbra.cnidarium.v1.QueryService.KeyValue
         */
        keyValue: {
            name: "KeyValue",
            I: KeyValueRequest,
            O: KeyValueResponse,
            kind: MethodKind.Unary,
        },
        /**
         * General-purpose key-value state query API, that can be used to query
         * arbitrary keys in the non-verifiable storage.
         *
         * @generated from rpc penumbra.cnidarium.v1.QueryService.NonVerifiableKeyValue
         */
        nonVerifiableKeyValue: {
            name: "NonVerifiableKeyValue",
            I: NonVerifiableKeyValueRequest,
            O: NonVerifiableKeyValueResponse,
            kind: MethodKind.Unary,
        },
        /**
         * General-purpose prefixed key-value state query API, that can be used to query
         * arbitrary prefixes in the JMT storage.
         *
         * @generated from rpc penumbra.cnidarium.v1.QueryService.PrefixValue
         */
        prefixValue: {
            name: "PrefixValue",
            I: PrefixValueRequest,
            O: PrefixValueResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Subscribes to a stream of key-value updates, with regex filtering on keys.
         *
         * @generated from rpc penumbra.cnidarium.v1.QueryService.Watch
         */
        watch: {
            name: "Watch",
            I: WatchRequest,
            O: WatchResponse,
            kind: MethodKind.ServerStreaming,
        },
    }
};
